import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputPhoneWithDropdown from 'apps/auth/components/form/InputPhoneWithDropdown';
import InputTextArea from 'apps/auth/components/form/InputTextArea';
import Form from 'apps/auth/components/form-multi/Form';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_PAY_NOTIFICATION_ACTION } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const GaSendSMS = (props) => {
    const { sendSmsButton, cancelSmsButton, sendSmsHeaderTitle, sendTransferName } = usePageMessages();
    const { defaultCountry } = useExtra();
    const { fields } = useForm(props.formName);
    return (
        <ModalComponent
            canCloseModal={false}
            rightHeaderComponent={<Button type="button" size="tight" variant="tertiary" caption={cancelSmsButton} onClick={() => props.toggleModal(false)} />}
        >
            <HeaderPanel title={sendSmsHeaderTitle} subtitle={sendTransferName} />
            <Form formName={props.formName} action={AUTH_PAY_NOTIFICATION_ACTION}>
                <Row indent="adaptive-32-48">
                    <InputPhoneWithDropdown
                        field={fields?.phone}
                        formName={props.formName}
                        defaultCountry={defaultCountry}
                        iso2={defaultCountry}
                        isNonEditableCountry
                    />
                </Row>
                <InputTextArea field={fields?.text} formName={props.formName} isNewInput />
                <FixedBottomPanel isRightAligned>
                    <Button type="submit" raised={true} caption={sendSmsButton} />
                </FixedBottomPanel>
            </Form>
        </ModalComponent>
    );
};

GaSendSMS.propTypes = {
    formName: PropTypes.string.isRequired,
};
export default connect(null, { toggleModal })(GaSendSMS);
